<template>
  <div>
    <breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Date</th>
          <th>Service</th>
          <th>Counter</th>
          <th>Bank</th>
          <th>EDC</th>
          <th>Giving</th>
          <th>Event</th>
          <th>Payment</th>
          <th>Member</th>
          <th>Total</th>
          <th>Edit</th>
        </tr>
        <tr v-for="(transactions_row, index) in transactions_list" :key="index">
          <td v-text="transactions_row.date_time"></td>
          <td v-text="transactions_row.service"></td>
          <td v-text="transactions_row.counter"></td>
          <td v-text="transactions_row.edc_bank"></td>
          <td v-text="transactions_row.edc"></td>
          <td v-text="transactions_row.giving"></td>
          <td v-text="transactions_row.event"></td>
          <td v-text="transactions_row.payment"></td>
          <td v-text="transactions_row.member"></td>
          <td v-text="transactions_row.total"></td>
          <td>
            <div class="field is-grouped">
              <div class="control">
                <button type="button" class="button is-warning" @click="editTransaction(transactions_row)"><i class="fa fa-edit"></i></button>
                <button type="button" class="button is-danger" @click="getModalConfirmation('Delete Transaction', 'Are you sure want to delete this transaction?', 'action', transactions_row)"><i class="fa fa-trash"></i></button>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      list_breadcrumbs: [],
      transactions_list: []
    }
  },
  created () {
    this.getTransactionsList()
  },
  methods: {
    getTransactionsList () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('frontdesk/get_my_transactions_list', {
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.transactions_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    editTransaction (transactionsRow) {
      if (transactionsRow.event === null) {
        this.$router.push('/panel/frontdesk/giving_update/' + transactionsRow.id)
      } else {
        this.$router.push('/panel/frontdesk/event_update/' + transactionsRow.id)
      }
    },
    executeModalAction (confirmData) {
      if (confirmData.label === 'action') {
        if (confirmData.flag === true) {
          var self = this
          var transactionsRow = confirmData.data
          self.flyPostSession('frontdesk/delete_transactions', {
            transactions_id: transactionsRow.id
          }).then(function (response) {
            if (response.data.response_code === 1) {
              self.$geb.emit({id: 'alert_modal', title: 'Transaction Delete Success!', content: 'Your transaction has been deleted', button_text: 'OK'})
              self.getTransactionsList()
            } else {
              var result = response.data.message
              self.errors.clear()
              for (var name in response.data.message) {
                self.errors.add(name, result[name])
              }
              self.$geb.emit({id: 'alert_modal', title: 'Transaction Delete Failed!', content: 'Your transaction can\'t be deleted', button_text: 'OK'})
            }
          }).catch(function (response) {
            self.errorMessage(response)
          })
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/MyTransactions.vue